let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("f8xBv"), load("c6MKV"), load("aZinD"), load("joJy8"), load("aHE9G"), load("jE5XU")]).then(() => parcelRequire('alFtm'));